import React from "react";
import { ListRefreshButtonWebView } from "./view";
import { styles } from "./styles";

export class ListRefreshButtonWeb extends React.Component {
  render() {
    return <ListRefreshButtonWebView {...this.props} styles={styles} />;
  }
}
